import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { ChatContainer } from '@/components/ChatContainer/ChatContainer';
import { IframeController } from '@/components/IframeController/IframeController';
import { Launcher } from '@/components/Launcher/Launcher';
import { SocketContext } from '@/contexts/socket';
import { useSocketSetup } from '@/hooks/useSocketSetup';
import { useWidgetState } from '@/hooks/useWidgetState';
import { autoOpenSelector, focusTrapSelector, themeSelector, widgetPositionSelector, } from '@/state/config';
import { hideWebchatState, isMobileSelector, isWidgetOpenState, } from '@/state/session';
import { PopupContainer } from './PopupContainer';
import styles from './AppContainer.module.scss';
export const AppContainer = () => {
    const { openWidget, closeWidget } = useWidgetState();
    const socket = useSocketSetup();
    const widgetPosition = useRecoilValue(widgetPositionSelector);
    const theme = useRecoilValue(themeSelector);
    const isMobile = useRecoilValue(isMobileSelector);
    const autoOpen = useRecoilValue(autoOpenSelector);
    const isWidgetOpen = useRecoilValue(isWidgetOpenState);
    const focusTrap = useRecoilValue(focusTrapSelector);
    const hideWebchat = useRecoilValue(hideWebchatState);
    const handlePopupClose = useCallback((e) => {
        e.preventDefault();
        closeWidget();
    }, [closeWidget]);
    useEffect(() => {
        if (autoOpen || widgetPosition === 'embed') {
            openWidget();
        }
    }, [autoOpen, widgetPosition, openWidget]);
    if (hideWebchat) {
        return null;
    }
    return (_jsx(SocketContext.Provider, { value: socket, children: _jsxs("div", { className: cn('appContainer', styles.container, styles[theme], styles[widgetPosition]), children: [_jsx(Launcher, {}), _jsx("div", { className: cn({
                        [styles.focusTrap]: focusTrap,
                        [styles.open]: isWidgetOpen,
                    }), children: widgetPosition === 'popup' && !isMobile ? (_jsx(PopupContainer, { isOpen: isWidgetOpen, onClose: handlePopupClose, children: _jsx(ChatContainer, {}) })) : (_jsx(ChatContainer, {})) }), _jsx(IframeController, {})] }) }));
};
